import {
  uploadJson,
  downloadJson,
  createFileEntry,
  getDownloadUrl,
} from "fileUtils";

export const storeSovOverrides = (data) =>
  uploadJson(data, "sov_overrides.json");
export const retrieveSovOverrides = (fileId) => downloadJson(fileId);
export const storeSovAnalytics = (data) =>
  uploadJson(data, "sov_analytics.json");
export const retrieveSovAnalytics = (fileId) => downloadJson(fileId);

/**
 * Stores SOV extraction data as a JSON file in S3
 * @param {Array} sovData - Array of SOV location objects
 * @param {string} originalFileName - Original filename for reference
 * @returns {Promise<{fileId: string, downloadUrl: string}>} Storage result
 */
export const storeSovExtractionData = async (sovData, originalFileName) => {
  const extractionData = {
    timestamp: new Date().toISOString(),
    originalFileName,
    sovData,
    version: "1.0",
    type: "sov_extraction_data",
  };

  const jsonContent = JSON.stringify(extractionData, null, 2);

  const jsonBlob = new Blob([jsonContent], { type: "text/plain" });
  const jsonFileName = `${originalFileName}_sov_data.json`;
  const jsonFile = new File([jsonBlob], jsonFileName, {
    type: "text/plain",
  });

  const uploadedFileId = await createFileEntry(jsonFile, false, null);

  const downloadUrl = await getDownloadUrl(uploadedFileId);

  return {
    fileId: uploadedFileId,
    downloadUrl: downloadUrl,
  };
};

/**
 * Retrieves stored SOV extraction data from S3 by file ID
 * @param {string} extractedDataFileId - File ID of stored SOV data
 * @returns {Promise<Array>} The SOV data array
 */
export const retrieveSovExtractionData = async (extractedDataFileId) => {
  const downloadUrl = await getDownloadUrl(extractedDataFileId);
  const requestUrl = downloadUrl.url || downloadUrl;

  const response = await fetch(requestUrl);
  if (!response.ok) {
    throw new Error(
      `Failed to retrieve SOV data: ${response.status} ${response.statusText}`
    );
  }

  const extractionData = await response.json();

  if (extractionData.type !== "sov_extraction_data") {
    throw new Error("Invalid SOV extraction data format");
  }

  return extractionData.sovData;
};
